import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBoxProps {
  initialValue?: string;
  placeholder?: string;
  large?: boolean;
}

export default function SearchBox({
  initialValue = '',
  placeholder = '搜索网站、分类或关键词，例如“在线工具”',
  large = false,
}: SearchBoxProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={
        large
          ? 'flex w-full items-center gap-2 rounded-lg border border-background-300 bg-background-50 p-2 pl-4 transition-colors focus-within:border-primary-400'
          : 'flex w-full items-center gap-1 rounded-md border border-background-300 bg-background-100 px-3 py-1.5 transition-colors focus-within:border-primary-400'
      }
    >
      <i className={`ri-search-line text-foreground-400 ${large ? 'text-lg' : 'text-base'}`}></i>
      <input
        type="text"
        name="q"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        className={`min-w-0 flex-1 bg-transparent text-foreground-800 placeholder:text-foreground-400 focus:outline-none ${
          large ? 'text-sm md:text-base' : 'text-sm'
        }`}
      />
      <button
        type="submit"
        className={`flex flex-shrink-0 items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 font-medium text-background-50 transition-colors hover:bg-primary-600 ${
          large ? 'h-9 px-4 text-sm md:h-10 md:px-6 md:text-base' : 'h-8 px-3 text-sm'
        }`}
      >
        <i className="ri-search-line md:hidden"></i>
        <span className="hidden md:inline">搜索</span>
      </button>
    </form>
  );
}